import { sendDwh } from 'reactApp/utils/ga';

export const sendFreemiumDisableAdsModalDwh = (action: 'show' | 'close' | 'click', name: string) => {
    sendDwh({
        eventCategory: 'modal',
        action,
        dwh_enabled: true,
        dwhData: {
            name,
        },
    });
};
